export default __webpack_public_path__ + "static/media/arrowML.3bca63eb.svg";